// HOTSLIP custom logo — purple shield with neon "H" mark + cyan flame accent
export const Logo = ({ size = 32 }) => (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="HOTSLIP logo">
        <defs>
            <linearGradient id="hotslip-shield" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0%" stopColor="#7c3aed" />
                <stop offset="100%" stopColor="#6f3fec" />
            </linearGradient>
            <filter id="hotslip-glow" x="-50%" y="-50%" width="200%" height="200%">
                <feGaussianBlur stdDeviation="1.5" result="b" />
                <feMerge>
                    <feMergeNode in="b" />
                    <feMergeNode in="SourceGraphic" />
                </feMerge>
            </filter>
        </defs>
        <path d="M14 4 L52 4 C56 4 58 7 58 11 L58 39 C58 44 55 47 50 50 L34 60 C32.5 60.8 30.5 60.8 29 60 L14 50 C9 47 6 44 6 39 L6 11 C6 7 9 4 14 4 Z" fill="url(#hotslip-shield)" />
        {/* H letterform */}
        <g filter="url(#hotslip-glow)">
            <rect x="19" y="16" width="6" height="32" rx="1" fill="#ffffff" />
            <rect x="39" y="16" width="6" height="32" rx="1" fill="#ffffff" />
            <rect x="19" y="28" width="26" height="6" rx="1" fill="#ffffff" />
        </g>
        {/* cyan flame dot */}
        <circle cx="50" cy="14" r="3.5" fill="#22d3ee" filter="url(#hotslip-glow)" />
    </svg>
);
